export const snackbar = {
  data () {
    return {
      _snackBar: false,
      _snackBarText: ''
    }
  },
  methods: {
    snack (text) {
      this._snackBarText = text
      this._snackBar = true
    },
    snackClose () {
      this._snackBar = false
    }
  },
  computed: {
    snackBar () {
      return this._snackBar
    },
    snackBarText () {
      return this._snackBarText
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/snackbar.js